import getColor from "@insite/mobius/utilities/getColor";
import { cartLineCardExpandedStyles as styles } from "@solveindustrial/Overrides/Components/CartLineCardExpanded";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    css: css`
        border: 1px solid ${getColor(colorStrings.commonBorder)};
        border-radius: 4px;
        padding: 16px;
        margin-bottom: 16px;
    `,
};

// We leave emppty to overwrite the default styles
styles.price = {};

styles.backorderedQtyGridItem = {
    ...styles.backorderedQtyWrapper,
    width: [12, 12, 12, 6, 6],
};

styles.backorderedQtyWrapper = {
    ...styles.backorderedQtyWrapper,
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

styles.quantityGridItem = {
    ...styles.quantityGridItem,
    width: [12, 12, 12, 6, 6],
};

styles.priceGridItem = {
    ...styles.priceGridItem,
    width: [12, 12, 12, 6, 6],
};

styles.extendedUnitNetPriceGridItem = {
    ...styles.extendedUnitNetPriceGridItem,
    width: [12, 12, 12, 6, 6],
};

styles.infoLabel = {
    ...styles.infoLabel,
    css: css`
        font-weight: 700;
        font-size: 16px;
        color: ${getColor(colorStrings.commonGlobalGrayText)};

        ${mediaQueriesBP.maxMD} {
            font-size: 14px;
        }
    `,
};

styles.infoValue = {
    ...styles.infoValue,
    css: css`
        font-size: 16px;
        color: ${getColor(colorStrings.commonGlobalGrayText)};

        ${mediaQueriesBP.maxMD} {
            font-size: 14px;
        }
    `,
};
